import React, { useEffect, useMemo, useState } from "react"
import { Button, Col, Container, Row } from "reactstrap"
import { useTranslation } from "react-i18next"
import { useSelector, useDispatch } from "react-redux"
import { useNavigate } from "react-router-dom"
import { Filter, FilterX } from "lucide-react"

import Table from "./components/TableComponent"
import Spinners from "components/Shared/Spinners"
import Filters from "components/Shared/Filters"

import {
  setPayload,
  resetPayload,
  toggleFilterVisibility,
} from "../../store/reducers/roleReducer"
import { getAllRolesLists } from "../../store/actions/roleAction"
import { usePermissions } from "hooks"
import { rest } from "lodash"

const Roles = () => {
  const { showAll, permissions } = usePermissions("roles")
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const { t } = useTranslation()
  document.title = t("Roles & Permissions | Yamama")

  const {
    loading,
    totalPages,
    totalCount,
    currentPage,
    roles,
    payload,
    isShowFilter,
  } = useSelector(state => state.RolesAndPermissions)

  const [trigger, setTrigger] = useState(false)
  const filters = useMemo(() => {
    return {
      keyword: {
        type: "text",
        placeholder: t("Search by name"),
        label: t("Search By"),
        colSize: 4,
      },
      order_by: {
        type: "select",
        placeholder: t("Select Order"),
        label: t("Select Order"),
        options: [
          { value: 1, label: t("Ascending") },
          { value: -1, label: t("Descending") },
        ],
        colSize: 4,
      },
      // status: {
      //   type: "select",
      //   placeholder: t("Filter by status"),
      //   label: t("Status"),
      //   options: [
      //     { label: t("Active"), value: "active" },
      //     { label: t("Inactive"), value: "inactive" },
      //   ],
      // },
    }
  }, [t])

  const getAllData = () => {
    dispatch(getAllRolesLists(payload))
  }

  const handleReset = () => {
    dispatch(resetPayload())
    setTrigger(!trigger)
  }

  useEffect(() => {
    getAllData()
  }, [trigger])

  if (loading) return <Spinners />

  return (
    <>
      <div className="page-content">
        <Container fluid>
          <Row>
            <Col xl="12">
              <div className="d-flex justify-content-between mb-4 align-items-center">
                <h4 className="card-title">{t("Roles")}</h4>

                <div className="d-flex gap-3">
                  {(showAll || permissions.includes("can_create")) && (
                    <button
                      className="main_btn"
                      onClick={() => navigate("/roles-and-permissions/create")}
                    >
                      {t("Add New")}
                    </button>
                  )}
                  <Button
                    color="primary"
                    onClick={() => dispatch(toggleFilterVisibility())}
                    title={t("Show/Hide Filter")}
                  >
                    {isShowFilter ? <FilterX /> : <Filter />}
                  </Button>
                </div>
              </div>
              {isShowFilter && (
                <Filters
                  filters={filters}
                  state={{ ...payload.filters, order_by: payload.order_by }}
                  setState={data => {
                    const { order_by, ...rest } = data
                    dispatch(
                      setPayload({
                        order_by: Number(order_by),
                        filters: { ...payload.filters, ...rest },
                      })
                    )
                  }}
                  handleSearch={() => setTrigger(!trigger)}
                  handleReset={handleReset}
                  Replace
                  with
                  actual
                  translation
                  function
                />
              )}
              <Table
                showEverything={showAll}
                permissions={permissions}
                currentPage={currentPage}
                perPage={payload.limit}
                totalPages={totalPages}
                roles={roles}
                loading={loading}
                totalCount={totalCount}
                onPageChange={page => {
                  dispatch(setPayload({ page_number: page }))
                  setTrigger(!trigger)
                }}
                trigger={() => setTrigger(!trigger)}
              />
            </Col>
          </Row>
        </Container>
      </div>
    </>
  )
}

export default Roles
